const ResearchContent = {
	meta: "Research",
	title: "Various methods to uncover pain points",
	paras: [
		"Research was primarily conducted by the Product team. I collaborated closely with Product owners to discuss solutions based on discoveries from both quantitative and qualitative research.",
		"To supplement this, I reviewed user behaviour videos to get a sense of how users were interacting with the UI.",
	],
	img01alt: "Whiteboard with stickies",
	img01caption:
		"I participated in lab testing cruise customers, gaining valuable insights that directly improved my designs",
	img02alt: "Hotjar heat map",
	img02caption:
		"I used tools like Hotjar to make design decisions based on insights",
	quote: {
		statement:
			"You’ve got to keep drilling down to find what you want... I just wanted to click for St. Petersburg",
		personna: "Kathleen, 54 - 'One-time cruiser'",
	},
};

export default ResearchContent;
